import { render, staticRenderFns } from "./ListAuditoriaView.vue?vue&type=template&id=10975976&"
import script from "./ListAuditoriaView.vue?vue&type=script&lang=ts&"
export * from "./ListAuditoriaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports